module.exports = __webpack_public_path__ + "img/cellVolt.68654c51.svg";